export const setMaxTextLength = (
  maxLength: number,
  text: string,
  defaultMaxLength: number
): number => {
  if (text.length < defaultMaxLength) {
    return Math.floor(maxLength - text.length + defaultMaxLength);
  }
  return defaultMaxLength;
};
